var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoCutPourServe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 325.351,
    height: 451.818,
    viewBox: "0 0 325.351 451.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4dbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1e7ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info_cut_pour_serve",
    transform: "translate(-135 -2744.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3228",
    "data-name": "Group 3228",
    transform: "translate(-189.324 -0.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cut_2",
    transform: "translate(91.324 20.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_14",
    "data-name": "Union 14",
    d: "M8340-524.478l45.443-45.443h38.646a5.263,5.263,0,0,1,5.166-4.261,5.262,5.262,0,0,1,5.26,5.26,5.262,5.262,0,0,1-5.26,5.26,5.263,5.263,0,0,1-5.165-4.259H8386.27l-44.856,44.857Z",
    transform: "translate(-7945.861 3298.182)",
    fill: "#bf55ed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cut_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3732",
    "data-name": "Path 3732",
    d: "M0,37.129V92.781a20.627,20.627,0,0,0,16.375,20.307,105.618,105.618,0,0,1,20.407,6.3,21.563,21.563,0,0,1,2.01.983c3.782,2.086,17.234,9.543,19.788,11.509A107.486,107.486,0,0,1,76.121,148.2a20.839,20.839,0,0,0,26.244,4.609l48.12-27.784a20.752,20.752,0,0,0,6.151-30.538A202.344,202.344,0,0,0,23.7,16.576,20.783,20.783,0,0,0,0,37.129",
    transform: "translate(324.324 2751.371)",
    fill: "#bf55ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_17",
    "data-name": "Union 17",
    d: "M8438.3-499.685v-6.16h7.7v-20.213q0-1.484.082-3.107l-4.537,3.767a2.945,2.945,0,0,1-.88.51,2.641,2.641,0,0,1-.854.151,2.576,2.576,0,0,1-1.278-.316,2.744,2.744,0,0,1-.839-.673L8435-529.3l12.486-10.477h7.039v33.935h6.6v6.16Z",
    transform: "translate(-8042 3358.182)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3227",
    "data-name": "Group 3227",
    transform: "translate(-189.324 0.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pour_2",
    transform: "translate(91.324 20.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_15",
    "data-name": "Union 15",
    d: "M8423.383-568.923H8340v-2h83.383a5.261,5.261,0,0,1,5.165-4.261,5.261,5.261,0,0,1,5.26,5.26,5.261,5.261,0,0,1-5.26,5.262A5.261,5.261,0,0,1,8423.383-568.923Z",
    transform: "translate(-7875.457 3519.235)",
    fill: "#91a8fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pour_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3731",
    "data-name": "Path 3731",
    d: "M72.723,171.719a105.6,105.6,0,0,0-4.6-21.095,18.647,18.647,0,0,1,8.251-22.07l52.166-30.118A18.55,18.55,0,0,1,155,107.591a201.9,201.9,0,0,1,14.8,76.124A201.9,201.9,0,0,1,155,259.836a18.55,18.55,0,0,1-26.46,9.154L76.371,238.872A18.647,18.647,0,0,1,68.12,216.8,105.545,105.545,0,0,0,72.6,196.72a19.372,19.372,0,0,1,.366-1.993c2.215-9.583-.247-23.007-.247-23.007",
    transform: "translate(352.166 2784.545)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_18",
    "data-name": "Union 18",
    d: "M8433.189-500.686v-2.75a4.987,4.987,0,0,1,.329-1.705,4.129,4.129,0,0,1,1.155-1.65l11.55-11.633q1.485-1.484,2.587-2.833a17.527,17.527,0,0,0,1.813-2.652,12.105,12.105,0,0,0,1.072-2.614,10.427,10.427,0,0,0,.359-2.763,5.343,5.343,0,0,0-1.143-3.672,4.429,4.429,0,0,0-3.479-1.278,5.4,5.4,0,0,0-1.761.274,5.3,5.3,0,0,0-1.429.743,4.943,4.943,0,0,0-1.088,1.1,5.828,5.828,0,0,0-.728,1.376,3.952,3.952,0,0,1-1.115,1.786,2.8,2.8,0,0,1-1.828.55c-.183,0-.38-.008-.591-.028s-.427-.045-.647-.083l-4.508-.8a15.057,15.057,0,0,1,1.689-5.226,12.581,12.581,0,0,1,3.109-3.712,12.551,12.551,0,0,1,4.249-2.213,17.535,17.535,0,0,1,5.142-.73,15.555,15.555,0,0,1,5.349.866,11.967,11.967,0,0,1,4.056,2.408,10.374,10.374,0,0,1,2.572,3.669,12.042,12.042,0,0,1,.894,4.689,12.9,12.9,0,0,1-.62,4.071,15.981,15.981,0,0,1-1.69,3.561,25.04,25.04,0,0,1-2.488,3.272q-1.418,1.583-3.012,3.2l-7.838,8.029a28.665,28.665,0,0,1,2.983-.7,15.872,15.872,0,0,1,2.766-.261h7.479a3.03,3.03,0,0,1,2.173.756,2.63,2.63,0,0,1,.8,1.994v4.95Z",
    transform: "translate(-7976 3490.182)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3226",
    "data-name": "Group 3226",
    transform: "translate(-189.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "serve_2",
    transform: "translate(91.324 20.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_16",
    "data-name": "Union 16",
    d: "M8424.088-527.64h-38.646L8340-573.083l1.414-1.414,44.856,44.857h37.819a5.263,5.263,0,0,1,5.165-4.259,5.262,5.262,0,0,1,5.26,5.26,5.262,5.262,0,0,1-5.26,5.26A5.263,5.263,0,0,1,8424.088-527.64Z",
    transform: "translate(-7945.861 3698.882)",
    fill: "#1f3a93"
  })), /*#__PURE__*/React.createElement("g", {
    id: "serve_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3730",
    "data-name": "Path 3730",
    d: "M58.581,224.766a107.567,107.567,0,0,0,17.288-16.029,21.338,21.338,0,0,1,26.829-4.708l47.333,27.328a21.2,21.2,0,0,1,6.286,31.217A202.35,202.35,0,0,1,24.221,340,21.229,21.229,0,0,1,0,318.986V264.215a21.086,21.086,0,0,1,16.719-20.725,105.62,105.62,0,0,0,20.322-6.341c.52-.221,1.022-.461,1.525-.72,3.537-1.823,18.254-9.482,20.016-11.663",
    transform: "translate(324.324 2828.973)",
    fill: "#1f3a93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_19",
    "data-name": "Union 19",
    d: "M8442.676-500.18a11.7,11.7,0,0,1-3.958-1.924,12.756,12.756,0,0,1-3.039-3.34,22.493,22.493,0,0,1-2.271-4.842l3.795-1.54a4.151,4.151,0,0,1,.977-.3,5.6,5.6,0,0,1,.95-.083,3.555,3.555,0,0,1,1.582.344,2.336,2.336,0,0,1,1.058,1,9.965,9.965,0,0,0,2.627,3.313,5.308,5.308,0,0,0,3.257,1.032,5.968,5.968,0,0,0,2.489-.482,5.419,5.419,0,0,0,1.761-1.238,5.169,5.169,0,0,0,1.06-1.718,5.572,5.572,0,0,0,.356-1.954,13.808,13.808,0,0,0-.178-2.323,3.034,3.034,0,0,0-1-1.773,5.671,5.671,0,0,0-2.489-1.14,20.8,20.8,0,0,0-4.634-.4v-5.885a17.2,17.2,0,0,0,4.044-.386,6.217,6.217,0,0,0,2.378-1.058,3.2,3.2,0,0,0,1.113-1.637,7.708,7.708,0,0,0,.276-2.117,5.3,5.3,0,0,0-1.143-3.644,4.429,4.429,0,0,0-3.479-1.278,5.324,5.324,0,0,0-1.759.276,5.287,5.287,0,0,0-1.432.741,5.051,5.051,0,0,0-1.087,1.1,5.91,5.91,0,0,0-.729,1.376,4,4,0,0,1-1.112,1.788,2.818,2.818,0,0,1-1.829.55c-.185,0-.38-.011-.592-.028s-.425-.047-.646-.083l-4.51-.8a15.053,15.053,0,0,1,1.692-5.224,12.528,12.528,0,0,1,3.106-3.712,12.594,12.594,0,0,1,4.25-2.215,17.541,17.541,0,0,1,5.141-.728,15.439,15.439,0,0,1,5.282.839,11.789,11.789,0,0,1,3.9,2.268,9.579,9.579,0,0,1,2.421,3.315,9.8,9.8,0,0,1,.823,3.973,13.011,13.011,0,0,1-.384,3.341,7.688,7.688,0,0,1-1.141,2.5,7.173,7.173,0,0,1-1.871,1.8,11.2,11.2,0,0,1-2.544,1.238q6.658,2.309,6.655,9.047a12.513,12.513,0,0,1-1.155,5.555,11.448,11.448,0,0,1-3.092,3.933,13.25,13.25,0,0,1-4.5,2.351,18.1,18.1,0,0,1-5.334.784A19,19,0,0,1,8442.676-500.18Z",
    transform: "translate(-8043 3620.497)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCutPourServe);
export default __webpack_public_path__ + "static/media/info_cut_pour_serve.2b6e36161dbac39c2633e42dcc921383.svg";
export { ForwardRef as ReactComponent };